var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.siteComponents)?_c('Wrapper',{staticClass:"p-gd-2 h-100",attrs:{"id":"sidebar-design-mobile"}},[_c('Overlay')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }